export default "__VITE_ASSET__DDRUDhJ2__"